import * as mutationTypes from "../mutation-types";
import {settings} from "./settings";
import {other_settings} from "./other_settings";
import {countries} from "./countries";
import {SST} from "./sst";
import { createI18n } from "@/i18n/index";

const i18n = createI18n();
/*
const fixings = []
const orders = []
const carriers=[]
const status=[]
const departures=[]
const active_status={
  "value": "paid",
  "title": "Orders",
  "filter": "NOT_STARTED"
}
const active_carriers=[]
const shipping_services = []
const shipping_departures=[]
const shipping_destinations=[]
const shipping_envelopes=[]
const shipping_options=[]
*/


const state = {
  settings: settings,
  other_settings: other_settings,
  countries:countries,
  user:{firstName:null,lastName:null,gender:'female'},
  SST:SST/*
  fixings: fixings,
  orders: orders,
  status: status,
  carriers: carriers,
  departures: departures,
  shipping_services: shipping_services,
  active_status:active_status,
  active_carriers:active_carriers,
  shipping_departures:shipping_departures,
  shipping_envelopes:shipping_envelopes,
  shipping_options:shipping_options,
  shipping_destinations:shipping_destinations*/
}

const getters = {
  settings: state => state.settings,
  other_settings: state => state.other_settings,
  countries: state => state.countries,
  user:state => state.user,
  SST: state => state.SST,/*
  fixings: state => state.fixings,
  orders: state => state.orders,
  status: state=> state.status,
  carriers: state => state.carriers,
  departures: state => state.departures,
  active_status: state => state.active_status,
  active_carriers: state => state.active_carriers,
  shipping_services: state => state.shipping_services,
  shipping_departures: state => state.shipping_departures,
  shipping_destinations: state => state.shipping_destinations,
  shipping_envelopes: state => state.shipping_envelopes,
  shipping_options: state => state.shipping_options,*/
  /*
  formattedTimeframe: state => {
    let options = { day: '2-digit', month: 'short' };
    let loc= state.settings.locale;
    let rsp=new Date(state.settings.datefrom).toLocaleDateString(loc || 'en', options);
    rsp += ' - ';
    rsp += new Date(state.settings.dateto).toLocaleDateString(loc || 'en', options);
    console.log('rspa',rsp);
    return rsp;
  },
  formattedDate: state => {
    let options = { day: '2-digit', month: 'short' };
    let loc= state.settings.locale;
    let rsp=new Date(state.settings.datefrom).toLocaleDateString(loc || 'en', options);
    return rsp;
  },
  formattedTimeframeMonth: state => {
    let loc= state.settings.locale;
    let rsp='';
    //console.log('ftfm',new Date(state.settings.datefrom).toLocaleDateString(loc || 'en', options))
    console.log('ddd',state.settings.monthfrom,state.settings.monthto);
    if (state.settings.monthfrom !== undefined)
    {
      if (state.settings.monthfrom.substr(0,7)!=state.settings.monthto.substr(0,7))
      {
        let options = { year: '2-digit', month: 'short' };
        rsp = new Date(state.settings.monthfrom).toLocaleDateString(loc || 'en', options);
        rsp+= ' - ';
        rsp+= new Date(state.settings.monthto).toLocaleDateString(loc || 'en', options);
      }
      else
      {
        let options = { year: 'numeric', month: 'short' };
        rsp=new Date(state.settings.monthfrom).toLocaleDateString(loc || 'en', options);
      }
      console.log('rspa',rsp);
      return rsp;
    }
    else
    {
      return null;
    }
  },
  formattedAmount: state => (x) =>{
    let fa='';
    if (!isNaN(x))
    {
      //console.log('userjs_64',x);
      let vl=parseFloat(x)
      //console.log(state.fixings,state.settings.currency);
      let xc=state.fixings.find(element => element.Currency==state.settings.currency ).Rate;
      //console.log('xc',state.settings.currency,state.fixings,xc,(vl*xc).toFixed(2));
      vl=vl*xc;
      fa=vl.toLocaleString(state.settings.locale||'en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      //fa=vl<0?'('+fa.replace('-','')+')'+' '+state.settings.currency:fa+' '+state.settings.currency;
      fa=vl<0?'('+fa.replace('-','')+')':fa;
    }
    else
    {
      //console.log('settingsjs_76',x);
      fa = x==null?'-':x;
      
    }
    return fa;
  },
  convertedAmount: state => (x) =>{
    let vl=parseFloat(x)
    //console.log(state.fixings,state.settings.currency);
    let xc=state.fixings.find(element => element.Currency==state.settings.currency ).Rate;
    //console.log('xc',state.settings.currency,state.fixings,xc,(vl*xc).toFixed(2));
    return (vl*xc).toFixed(2);
  },
  formattedNumber: state => (x) =>{
    let vl=parseFloat(x)
     let fa=vl.toLocaleString(state.settings.locale||'en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    fa=vl<0?'('+fa.replace('-','')+')':fa;
    return fa;
  },
  */
  async LOADER(){
    console.log(137,'LOADER');
    let jwt=sessionStorage.getItem('jwt');
    try{
        const res = await this.$http.post('/settings/settings_read.php', {"jwt":jwt});
        if (res.data.errorid=='0')
        { 
          //console.log('LOADER',res.data.settings);
          actions.dispatch("setSettings", res.data.settings);
          actions.setSettings(res.data.settings);
        }
        else
        {
          this.$router.push('/auth/login').catch(() => {});
        }      
    } catch(e)
    {
      //this.$router.go();
    }
  },
};


const mutations = {
  [mutationTypes.SET_PUSH_TBM]: (state, payload) => {
    //state.settings=payload;  
    //console.log('SET_PUSH_TBM_B',state.settings.TBM,payload);
    //state.settings.brand=null;
    state.settings.TBM=payload;
    //console.log('SET_PUSH_TBM_A',state.settings.TBM);
  }, 
  [mutationTypes.SET_PUSH_SUBSCRIBED]: (state, payload) => {
    //state.settings=payload;  
    //console.log('SET_PUSH_SUBSCRIBED_B',state.settings.pushSubscribed,payload);
    //state.settings.brand=null;
    state.settings.pushSubscribed=payload;
    //console.log('SET_PUSH_SUBSCRIBED_A',state.settings.pushSubscribed);
  },   
  [mutationTypes.SET_TEMP_BRAND]: (state, payload) => {
    //state.settings=payload;  
    //console.log('SET_TEMP_BRAND_B',state.settings.brand,state.settings.tempBrand,payload);
    //state.settings.brand=null;
    state.settings.brand=payload;
    //console.log('SET_TEMP_BRAND_A',state.settings.tempBrand,state.settings.brand);
  },  
  [mutationTypes.SET_SETTINGS]: (state, payload) => {
    //state.settings=payload;  
    //console.log('SETTINGS_B',state.status,payload);
    state.settings=payload; 
    //Object.assign(state.settings,payload);
    //console.log('SETTINGS_A',state.status,state.settings);
    //Object.assign(state.settings,payload);
    //i18n.loadLanguageAsync(state.settings.locale);
  },
  [mutationTypes.SYNCHRO]: (state, payload) => {
    //const { action, ...rest } = payload;
    //console.log('synchroB',state[action]);
    state[payload.action]=payload.pl;
    //console.log('synchroA',payload.action,state[payload.action]);
  },
  [mutationTypes.SET_ORDERS]: (state, payload) => {
    //console.log('orders_B',state.orders,payload);
    state.orders=payload; 
    //console.log('orders_A',state.orders);
  },
  [mutationTypes.SET_STATUS]: (state, payload) => {
    //console.log('status_B',state.status,payload);
    state.status=payload; 
    //console.log('status_A',state.status);
  },
  [mutationTypes.SET_LOCALE]: (state, payload) => {
    state.settings.locale=payload;
    i18n.loadLanguageAsync(payload);
    console.log('locale_A',state.settings.locale);
  },
  [mutationTypes.SET_CURRENCY]: (state, payload) => {
    state.settings.currency=payload;
  },
  [mutationTypes.SET_DATE]: (state, payload) => {
    state.settings.date=payload;
  },  
  [mutationTypes.SET_AVATAR]: (state, payload) => {
    //console.log('avatar_B',state.settings.options,payload);
    state.settings.options.avatar=payload;
    //Object.assign(state.settings.options.avatar,payload);
    //console.log('avatar_A',state.settings.options.avatar);
  },
  [mutationTypes.TOGGLE_SPEND_MODAL]: (state,payload) => {
    //console.log('spendmodal_B',state.settings.spendmodal,payload);
    state.settings.spendmodal=payload;
    //console.log('spendmodal_A',state.settings.spendmodal,payload);
  },
  [mutationTypes.SET_USER_CREDITS]: (state,payload) => {
    //console.log('credits_B',state.settings.credits,payload);
    state.settings.credits=payload;
    //console.log('credits_A',state.settings.credits,payload);
    },
  [mutationTypes.SET_TIMEFRAME]: (state,payload) => {
    //console.log('tf_B',payload);
    state.settings.datefrom=payload[0];
    state.settings.dateto=payload[1];
    //console.log('tf_A',state.settings.datefrom,state.settings.dateto);
    },
  [mutationTypes.SET_MONTH_TIMEFRAME]: (state,payload) => {
    //console.log('tf_B',payload);
    state.settings.monthfrom=payload[0];
    state.settings.monthto=payload[1];
    //console.log('tf_A',state.settings.monthfrom,state.settings.monthto);
    },/*
    [mutationTypes.SET_MODAL]: (state,payload) => {
      console.log('modal_B',state.user[payload],payload);
      state.user[payload]=!state.user[payload];
      console.log('modal_A',state.user[payload],state.user);
      },
    [mutationTypes.SET_EBAY_ACCOUNTS]: (state, payload) => {
      console.log('set_ebay_accounts',payload);
      state.user.eb_dialog=true;
      state.user.eBayAD=payload.eBayAD;
      console.log('set_ebay_accountsA',state.user);
    },
    [mutationTypes.SET_PLAFOND]: (state, payload) => {
      console.log('set_plafond',payload);
      state.user.plafond=payload;
      console.log('set_plafondA',state.user);
    },
    [mutationTypes.SET_MESSAGESCOUNT]: (state, payload) => {
      console.log('set_messagesCountB',payload);
      state.user.messagesCount=payload;
      console.log('set_messagesCountA',state.user);
    },*/
    [mutationTypes.SET_NEW_BOOKINGS_ALERT]: (state, payload) => {
      //console.log('set_newBookingsAlertB',payload);
      state.settings.newBookingsAlert=payload;
      //console.log('set_newBookingsAlertA',state.settings);
    },      
    [mutationTypes.SET_DISABLE_SAME_DAY_BOOKING]: (state, payload) => {
      console.log('271-SET_DISABLE_SAME_DAY_BOOKING_before',payload);
      state.settings.options.disableSameDayBooking=payload;
      console.log('SET_DISABLE_SAME_DAY_BOOKING_after',state.settings);
    },
    [mutationTypes.SET_TBM]: (state, payload) => {
      console.log('271-SET_TBM_before',payload.cnt);
      state.settings.tbm=payload.cnt;
      console.log('SET_TBM_after',state.settings);
    },    
  };

 const actions = {
  setTitle(title) {
    document.title = title  
  },
  setSettings: ({ commit }, payload) => {
    commit(mutationTypes.SET_SETTINGS, payload);
  },
  synchro: ({ commit }, payload) => {
    commit(mutationTypes.SYNCHRO, payload);
  },
  setOrders: ({ commit }, payload) => {
    commit(mutationTypes.SET_ORDERS, payload);
  },
  setStatus: ({ commit }, payload) => {
    commit(mutationTypes.SET_STATUS, payload);
  },  
  setActiveStatus: ({ commit }, payload) => {
    commit(mutationTypes.SET_ACTIVE_STATUS, payload);
  },
  setLocale: ({ commit }, payload) => {
    commit(mutationTypes.SET_LOCALE, payload);
  },
  setDate: ({ commit }, payload) => {
    commit(mutationTypes.SET_DATE, payload);
  },
  setCurrency: ({ commit }, payload) => {
    commit(mutationTypes.SET_CURRENCY, payload);
  },
  setFixings: ({ commit }, payload) => {
    commit(mutationTypes.SET_FIXINGS, payload);
  },
  setAvatar: ({ commit }, payload) => {
    console.log('setAvatar',payload)
    commit(mutationTypes.SET_AVATAR, payload);
  },
  toggleSpendModal: ({ commit }, payload) => {
    commit(mutationTypes.TOGGLE_SPEND_MODAL,payload);
  },
  set_user_credits: ({ commit }, payload) => {
    commit(mutationTypes.SET_USER_CREDITS, payload);
  },
  set_timeframe: ({ commit }, payload) => {
    commit(mutationTypes.SET_TIMEFRAME, payload);
  },
  set_month_timeframe: ({ commit }, payload) => {
    commit(mutationTypes.SET_MONTH_TIMEFRAME, payload);
  },
  set_Modal: ({ commit }, payload) => {
    commit(mutationTypes.SET_MODAL, payload);
  },
  seteBayAccounts: ({ commit }, payload) => {
    commit(mutationTypes.SET_EBAY_ACCOUNTS, payload);
  },
  setPlafond: ({ commit }, payload) => {
    commit(mutationTypes.SET_PLAFOND, payload);
  },
  setMessagesCount: ({ commit }, payload) => {
    commit(mutationTypes.SET_MESSAGESCOUNT, payload);
  },
  setNewBookingsAlert: ({ commit }, payload) => {
    commit(mutationTypes.SET_NEW_BOOKINGS_ALERT, payload);
  },
  setTempBrand:  ({ commit }, payload) => {
    commit(mutationTypes.SET_TEMP_BRAND, payload);
  },
  setPushSubscribed:  ({ commit }, payload) => {
    commit(mutationTypes.SET_PUSH_SUBSCRIBED, payload);
  },
  setTBM:  ({ commit }, payload) => {
    commit(mutationTypes.SET_TBM, payload);
  },   
  setDisableSameDayDirectBooking:  ({ commit }, payload) => {
    commit(mutationTypes.SET_DISABLE_SAME_DAY_BOOKING, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};